import { render } from "./ArrowBack.vue?vue&type=template&id=c665136c&scoped=true"
const script = {}

import "./ArrowBack.vue?vue&type=style&index=0&id=c665136c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c665136c"]])

export default __exports__